import { gql } from '@apollo/client';

export const DIRECTUS_WHATS_NEW = gql`
  query DirectusWhatsNew($code: String!) {
    whats_new {
      id
      friendly_name
      whats_new_translations(filter: { languages_code: { code: { _contains: $code } } }) {
        id
        title
        languages_code {
          code
        }
      }
    }
  }
`;
